import axios from "axios";

import { API_HOST } from "../config/config";

export const api = axios.create({
    baseURL: API_HOST + "v2/ultimate-portfolio" 
});

export const excludedCountries2Step = ["MNE"];